import useSubmit from "./useSubmit";
import { FormikHelpers } from "formik";
import { AxiosRequestConfig } from "axios";
import { deleteTransferOrderRowsByTransferOrderId, updateTransferOrderRowsByTransferOrderId } from "src/utils/apiRequests";
import { buildTransferOrderRequest } from "src/utils/submit/submitRequests";
import { remove } from "nprogress";


export const useTransferOrderSubmit = (): [any, (values: any, changedRows: any, formikHelpers: FormikHelpers<any>) => any] => {

  const combinedRequests = ({ values, changedRows }: { values: any; changedRows: any; }): AxiosRequestConfig<any>[] => {
    const IsCreateRequest = values?.OrderId == null || values?.OrderId == 0;
    const mainReq = buildTransferOrderRequest(values);
    const mainRequests = Array.isArray(mainReq) ? mainReq : [mainReq];
    const rowRequests = transferOrderRowsPostRequests({ values, changedRows });
    return IsCreateRequest ? mainRequests : [...rowRequests, ...mainRequests];
  };

  const [resultMain, submitMain] = useSubmit<any>(combinedRequests, { logLevel: ["error", "success"], sequential: true });


  const submitTransferOrder = (
    values: any,
    changedRows: any,
    formikHelpers: FormikHelpers<any>
  ) => {
    // console.log("submit Transfer Order", values, changedRows);

    submitMain({ values, changedRows }, formikHelpers);
  };

  return [resultMain, submitTransferOrder];
};


export const transferOrderRowsPostRequests = ({ values, changedRows }) => {
  const originalRows = values.TransferOrderRows || [];

  // "changedRows" is actually the CURRENT rows after user actions (since missing = deleted)
  const currentRows = changedRows || [];

  const originalById = new Map(originalRows.map(r => [r.OrderRowId, r]));

  const originalIds = new Set(originalRows.map(r => r.OrderRowId));
  const currentExistingIds = new Set(currentRows.map(r => r.OrderRowId).filter(id => id > 0));
  const removedIds = [...originalIds].filter(id => !currentExistingIds.has(id));

  const hasRowChanged = (orig, cur) => {
    if (!orig) return true; // new
    // compare fields that matter (exclude computed/noisy fields)
    const ignore = new Set(["AvailableQtyAtTime"]);
    const keys = new Set([...Object.keys(orig), ...Object.keys(cur)]);
    for (const k of keys) {
      if (ignore.has(k)) continue;
      if (orig[k] !== cur[k]) return true;
    }
    return false;
  };

  const updateRows = currentRows
    .map(row => {
      if (row.OrderRowId > 0) {
        const orig = originalById.get(row.OrderRowId);
        if (!hasRowChanged(orig, row)) return null; // unchanged -> don't send
        return row;
      } else {
        const { OrderRowId, ...rest } = row; // new -> send without id
        return rest;
      }
    })
    .filter(Boolean);

  const deleteRows = removedIds.map(id => ({ OrderRowId: id }));

  const requests = [];
  if (updateRows.length > 0) requests.push(updateTransferOrderRowsByTransferOrderId(values.OrderId, updateRows));
  if (deleteRows.length > 0) requests.push(deleteTransferOrderRowsByTransferOrderId(values.OrderId, deleteRows));

  console.log("Transfer Order Row Requests", {
    originalRows,
    removedIds,
    updateRows,
    deleteRows,
    updateRowsCount: updateRows.length,
    deleteRowsCount: deleteRows.length,
    requestsCount: requests.length
  });

  return requests;
};
